var exports = {
  "K": "xaf9ae18d--c1c9a3--icon",
};

module.exports = exports;
